const getFirstScreenshotIndexForAllScrapedItems = firstScreenshotIndexByScrapedItemHash =>
  new Map(
    Array.from(firstScreenshotIndexByScrapedItemHash, itemMap =>
      itemMap.reverse(),
    ),
  )

export default getFirstScreenshotIndexForAllScrapedItems
